<template>
  <div class="gsl-hrm-paper-container">
    <table-header
      :total="total"
      :loading="isLoading"
      :selected="checkedItems.length"
      :show-divider="false"
    ></table-header>
    <div class="gsl-hrm-container">
      <oxd-card-table
        v-model:selected="checkedItems"
        :headers="headers"
        :items="items?.data"
        :selectable="false"
        :clickable="false"
        :loading="isLoading"
        class="gsl-hrm-allocation-list"
        row-decorator="oxd-table-decorator-card"
      />
    </div>
    <div class="gsl-hrm-bottom-container">
      <oxd-pagination
        v-if="showPaginator"
        v-model:current="currentPage"
        :length="pages"
      />
    </div>
  </div>
</template>
<script>
import {h} from 'vue';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@ohrm/core/util/composable/usePaginate';
import StatusCell from '@ohrm/core/components/table/StatusCell';

export default {
  name: 'ProjectAllocation',

  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
  },
  setup(props) {
    const http = new APIService(
      window.appGlobal.baseUrl,
      `/api/v2/time/project/${props.projectId}/project-allocation`,
    );

    const projectAllocationDataNormalizer = (data) => {
      return data.map((item) => {
        const endDate = new Date(item.endDate);
        const currentDate = new Date();

        // Determine the status based on the endDate
        const status = endDate < currentDate ? 'Inactive' : 'Active';
        return {
          ...item,
          employeeName: item.employee.firstName + ' ' + item.employee.lastName,
          status: status,
          role: item?.role?.name || '-',
          percentage: item.percentage + '%',
        };
      });
    };
    const {
      showPaginator,
      currentPage,
      total,
      pages,
      pageSize,
      response,
      isLoading,
      execQuery,
    } = usePaginate(http, {
      normalizer: projectAllocationDataNormalizer,
      toastNoRecords: false,
    });
    return {
      http,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      pageSize,
      execQuery,
      items: response,
    };
  },

  data() {
    return {
      headers: [
        {
          name: 'employeeName',
          slot: 'title',
          title: this.$t('general.employee_name'),
          style: {flex: 1},
        },

        {
          name: 'startDate',
          title: this.$t('general.start_date'),
          style: {flex: 1},
        },
        {
          name: 'endDate',
          title: this.$t('general.end_date'),
          style: {flex: 1},
        },
        {
          name: 'status',
          slot: 'action',
          title: this.$t('general.status'),
          style: {flex: 1},
          cellRenderer: this.cellRenderer,
        },
        {
          name: 'role',
          title: this.$t('general.role'),
          style: {flex: 1},
        },
        {
          name: 'percentage',
          title: this.$t('general.percentage_of_allocation'),
          style: {flex: 1},
        },
      ],
      checkedItems: [],
    };
  },
  computed: {
    tableHeaders() {
      return this.headers;
    },
  },

  methods: {
    async resetDataTable() {
      await this.execQuery();
    },

    cellRenderer(...args) {
      const cellData = args[1];
      return {
        component: StatusCell,
        props: {
          data: cellData,
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.gsl-hrm-allocation-list {
  ::v-deep(.card-header-slot) {
    border-bottom: $oxd-input-control-border--active;
    margin-bottom: 5px;
  }

  ::v-deep(.card-body-slot) {
    display: unset;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0.2rem;
  }
  ::v-deep(.card-header-slot-content.--right) {
    justify-items: center;
    align-items: center;
    display: flex;
  }
}
</style>
